export default __webpack_public_path__ + "static/media/offer.4b3fc49b.png";